<template>
    <modal title="Create Cookie" :size="'xl'" @close="$emit('close')">
        <template #content>
            <load-area v-if="data==null"></load-area>
            <pre v-if="data!=null" class="m-0">{{data}}</pre>
        </template>
    </modal>
</template>

<script>
    export default {
        name:"detail",
        props:{
            id:Number
        },
        data(){
            return {
                data:null
            }
        },
        created(){
            this.$appAxiosAdmin.post(`Operators/Cookies/`+this.id,{}).then(response => {
                this.data=response.data;
                this.$emit("get")
            }).catch(err=>{
                this.data=err;
            });
        }
    }
</script>

<style>

</style>